
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("jVa6Y", function(module, exports) {
$parcel$export(module.exports, "Input", function () { return (parcelRequire("irRyj")).Input; });
$parcel$export(module.exports, "InputIcon", function () { return (parcelRequire("6nMZs")).InputIcon; });
$parcel$export(module.exports, "Login", function () { return (parcelRequire("lJMiD")).Login; });
$parcel$export(module.exports, "LogoButton", function () { return (parcelRequire("iTWJZ")).LogoButton; });
$parcel$export(module.exports, "ProviderLogo", function () { return (parcelRequire("iTWJZ")).ProviderLogo; });
$parcel$export(module.exports, "Separator", function () { return (parcelRequire("1WLWt")).Separator; });
$parcel$export(module.exports, "Social", function () { return (parcelRequire("32ARy")).Social; });
$parcel$export(module.exports, "Submit", function () { return (parcelRequire("l7G9R")).Submit; });
$parcel$export(module.exports, "useAccountCreationContext", function () { return (parcelRequire("cGEBM")).useAccountCreationContext; });
$parcel$export(module.exports, "default", function () { return $4e0aa450913abeb5$export$2e2bcd8739ae039; });

var $6KUQg = parcelRequire("6KUQg");
parcelRequire("1FWHc");
parcelRequire("9ktVo");
var $4e0aa450913abeb5$export$2e2bcd8739ae039 = (0, $6KUQg.AccountCreation);

});
parcelRegister("6KUQg", function(module, exports) {
$parcel$export(module.exports, "AccountCreation", function () { return $42aa4ee4b4afed63$export$b841b541bc741e79; });

var $6ogO3 = parcelRequire("6ogO3");

var $aPnCa = parcelRequire("aPnCa");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1FWHc");
var $7u4F3 = parcelRequire("7u4F3");
parcelRequire("9ktVo");
var $cGEBM = parcelRequire("cGEBM");
const $42aa4ee4b4afed63$export$b841b541bc741e79 = (_param)=>{
    var { continueUrl: continueUrl, identityCobranding: identityCobranding, templateId: templateId } = _param, props = (0, $aPnCa._)(_param, [
        "continueUrl",
        "identityCobranding",
        "templateId"
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cGEBM.AccountCreationContextProvider), {
        continueUrl: continueUrl,
        identityCobranding: identityCobranding,
        templateId: templateId,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7u4F3.Content), (0, $6ogO3._)({}, props))
    });
};

});
parcelRegister("1FWHc", function(module, exports) {
$parcel$export(module.exports, "Content", function () { return (parcelRequire("7u4F3")).Content; });
$parcel$export(module.exports, "Input", function () { return (parcelRequire("irRyj")).Input; });
$parcel$export(module.exports, "InputIcon", function () { return (parcelRequire("6nMZs")).InputIcon; });
$parcel$export(module.exports, "Login", function () { return (parcelRequire("lJMiD")).Login; });
$parcel$export(module.exports, "Separator", function () { return (parcelRequire("1WLWt")).Separator; });
$parcel$export(module.exports, "LogoButton", function () { return (parcelRequire("iTWJZ")).LogoButton; });
$parcel$export(module.exports, "ProviderLogo", function () { return (parcelRequire("iTWJZ")).ProviderLogo; });
$parcel$export(module.exports, "Social", function () { return (parcelRequire("32ARy")).Social; });
$parcel$export(module.exports, "Submit", function () { return (parcelRequire("l7G9R")).Submit; });
parcelRequire("MNUwH");
parcelRequire("f5lYY");
parcelRequire("7PpcD");
parcelRequire("1p00m");
parcelRequire("bncEF");
parcelRequire("1WLWt");
parcelRequire("k0W5w");
parcelRequire("kHTHh");

});
parcelRegister("MNUwH", function(module, exports) {
$parcel$export(module.exports, "Content", function () { return (parcelRequire("7u4F3")).Content; });
parcelRequire("7u4F3");

});
parcelRegister("7u4F3", function(module, exports) {
$parcel$export(module.exports, "Content", function () { return $6cc2293976038b02$export$7c6e2c02157bb7d2; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $lX14w = parcelRequire("lX14w");
parcelRequire("9ktVo");
var $cGEBM = parcelRequire("cGEBM");
parcelRequire("f5lYY");
var $mG5bv = parcelRequire("mG5bv");
parcelRequire("7PpcD");
var $irRyj = parcelRequire("irRyj");
parcelRequire("bncEF");
var $lJMiD = parcelRequire("lJMiD");

var $1WLWt = parcelRequire("1WLWt");
parcelRequire("k0W5w");
var $32ARy = parcelRequire("32ARy");
parcelRequire("kHTHh");
var $l7G9R = parcelRequire("l7G9R");
const $6cc2293976038b02$export$7c6e2c02157bb7d2 = ({ Submit: Submit = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l7G9R.Submit), {}), Input: Input = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $irRyj.Input), {}), Social: Social = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $32ARy.Social), {}), Separator: Separator = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1WLWt.Separator), {}), Error: Error = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $mG5bv.Error), {}), Login: Login = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lJMiD.Login), {}) })=>{
    const { onSubmitWithReCAPTCHA: onSubmitWithReCAPTCHA } = (0, $cGEBM.useAccountCreationContext)();
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lX14w.default), {
                onSubmit: onSubmitWithReCAPTCHA,
                isDisabled: false,
                children: ({ formProps: formProps })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("form", (0, $dPABA._)((0, $6ogO3._)({}, formProps), {
                        autoComplete: "off",
                        "data-testid": "account-creation",
                        children: [
                            Input,
                            Submit
                        ]
                    }))
            }),
            Error,
            Separator,
            Social,
            Login
        ]
    });
};

});
parcelRegister("9ktVo", function(module, exports) {
$parcel$export(module.exports, "AccountCreationContextProvider", function () { return (parcelRequire("cGEBM")).AccountCreationContextProvider; });
$parcel$export(module.exports, "useAccountCreationContext", function () { return (parcelRequire("cGEBM")).useAccountCreationContext; });
parcelRequire("cGEBM");

});
parcelRegister("cGEBM", function(module, exports) {
$parcel$export(module.exports, "useAccountCreationContext", function () { return $835e146085c3a79b$export$30b295205cfae694; });
$parcel$export(module.exports, "AccountCreationContextProvider", function () { return $835e146085c3a79b$export$b0a1b3550379fc78; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $eLTTO = parcelRequire("eLTTO");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $7VwhR = parcelRequire("7VwhR");

var $jmley = parcelRequire("jmley");

var $doAVE = parcelRequire("doAVE");

var $PE2DD = parcelRequire("PE2DD");

var $32ng3 = parcelRequire("32ng3");

var $1ka2O = parcelRequire("1ka2O");

var $iSeHD = parcelRequire("iSeHD");
const { IDENTITY_USER_SIGNUP_API: $835e146085c3a79b$var$IDENTITY_USER_SIGNUP_API } = (0, $7VwhR.UfoCustomTimingKey);
const $835e146085c3a79b$export$52bc2238e0ff8657 = /*#__PURE__*/ (0, $1oC0p.createContext)(null);
const $835e146085c3a79b$export$30b295205cfae694 = ()=>{
    const context = (0, $1oC0p.useContext)($835e146085c3a79b$export$52bc2238e0ff8657);
    if (!context) throw new Error("useAccountCreationContext must be used within a AccountCreationContextProvider");
    return context;
};
const $835e146085c3a79b$export$b0a1b3550379fc78 = ({ continueUrl: continueUrl, identityCobranding: identityCobranding = "wac", templateId: templateId, children: children })=>{
    const location = (0, $1ka2O.useLocation)();
    const isEmbedded = !location.pathname.endsWith("/try/cloud/signup");
    const { product: product, edition: edition } = (0, $doAVE.useUserContext)();
    const analyticsClient = (0, $iSeHD.useAnalyticsClient)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const intl = (0, $8e22h.default)();
    const [isEmailValid, setIsEmailValid] = (0, $1oC0p.useState)(false);
    const [hasSubmitted, setHasSubmitted] = (0, $1oC0p.useState)(false);
    const [isReadyForInvalid, setIsReadyForInvalid] = (0, $1oC0p.useState)(false);
    const [isSubmitting, setIsSubmitting] = (0, $1oC0p.useState)(false);
    const [formError, setFormError] = (0, $1oC0p.useState)(false);
    const [_email, setEmail] = (0, $1oC0p.useState)("");
    const [typeAheadEmail, setTypeAheadEmail] = (0, $1oC0p.useState)("");
    const [onSubmitProps, setOnSubmitProps] = (0, $1oC0p.useState)(undefined);
    const [recaptchaFailedToLoad, setRecaptchaFailedToLoad] = (0, $1oC0p.useState)(false);
    const [recaptchaRetryTimeRemainingSecond, setRecaptchaRetryTimeRemainingSecond] = (0, $1oC0p.useState)(60);
    const [tryIntentAnalyticsEventHasFired, setTryIntentAnalyticsEventHasFired] = (0, $1oC0p.useState)(false);
    const localePath = (0, $7VwhR.getLocalePath)(intl.locale);
    const signupClient = (0, $PE2DD.useBxpWebStargateClient)();
    const { executeRecaptcha: executeRecaptcha } = (0, $eLTTO.useGoogleReCaptcha)();
    const continueParam = (0, $7VwhR.getContinueParam)(location);
    // identity interstitial redirect experiments
    const interstitialRedirectEnabled = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).signupAccountCreationInterstitial);
    const dataFoundationsActionSubjectId = !!isEmbedded ? "embedded" : "standalone";
    // default experiment params
    if (product && identityCobranding === "wac") {
        if (product.name === "confluence") identityCobranding = "wac--otp-confluence";
        else if (product.name === "jira") identityCobranding = "wac--otp-jira";
        else if (product.name === "loom") identityCobranding = "wac--loom";
        else if (product.name === "jira-product-discovery") identityCobranding = "wac--jpd";
        else if (product.name === "jira-servicedesk") identityCobranding = "wac--jsm";
        else if (product.name === "service-collection") identityCobranding = "wac--service-collection";
        else if (product.name === "teamwork-collection") identityCobranding = "wac--teamwork-collection";
    }
    const redirectTo = continueUrl ? continueUrl : continueParam ? continueParam : (0, $7VwhR.getNameYourSiteRedirectUrl)({
        bundle: product === null || product === void 0 ? void 0 : product.bundle,
        edition: edition,
        localePath: localePath,
        templateId: templateId,
        application: identityCobranding
    });
    (0, $1oC0p.useEffect)(()=>{
        if (!analyticsClient) return;
        (0, $7VwhR.trackDataFoundationsAccountCreationComponent)(createAnalyticsEvent, {
            actionSubjectId: dataFoundationsActionSubjectId,
            productKey: product === null || product === void 0 ? void 0 : product.key,
            edition: edition
        });
        (0, $7VwhR.ufoEventSignupFormLoad).success({
            customData: {
                webPlatform: "bxp-ui",
                reactComponent: "DefaultSignupForm",
                isLoggedIn: false
            }
        });
        (0, $7VwhR.trackSignFormLoad)(createAnalyticsEvent);
        (0, $7VwhR.trackTimeToFormReady)(createAnalyticsEvent, performance.now());
    }, [
        createAnalyticsEvent,
        edition,
        product === null || product === void 0 ? void 0 : product.key,
        dataFoundationsActionSubjectId,
        analyticsClient
    ]);
    const onSubmitWithReCAPTCHA = (0, $1oC0p.useCallback)(// eslint-disable-next-line complexity
    async ({ email: email })=>{
        setIsReadyForInvalid(true);
        if (!email || !isEmailValid) {
            (0, $7VwhR.trackInvalidEmail)(createAnalyticsEvent);
            return;
        }
        (0, $7VwhR.trackFormSubmit)(createAnalyticsEvent, product === null || product === void 0 ? void 0 : product.key, edition);
        try {
            // check identity interstitial redirect experiments for enrollment
            if (interstitialRedirectEnabled) {
                const url = (0, $7VwhR.getIdentityInterstitialUrl)(email, redirectTo, identityCobranding);
                createAnalyticsEvent({
                    eventType: "ui",
                    action: "succeeded",
                    actionSubject: "accountCreationInterstitialRedirect",
                    containerId: "bxp-ui-signup",
                    attributes: {
                        productKey: product === null || product === void 0 ? void 0 : product.key,
                        edition: edition
                    }
                }).fire();
                window.location.assign(url);
                return;
            }
        } catch (error) {
            createAnalyticsEvent({
                eventType: "ui",
                action: "errored",
                actionSubject: "accountCreationInterstitialRedirect",
                containerId: "bxp-ui-signup",
                attributes: {
                    productKey: product === null || product === void 0 ? void 0 : product.key,
                    edition: edition
                }
            }).fire();
        }
        setOnSubmitProps({
            email: email
        });
        setIsSubmitting(true);
        if (!executeRecaptcha && recaptchaRetryTimeRemainingSecond > 0) {
            // set trigger that will wait for Recaptcha retry logic
            setFormError(true);
            setIsSubmitting(false);
            setRecaptchaFailedToLoad(true);
            return;
        }
        setRecaptchaFailedToLoad(false);
        // Start UFO to begin duration measurements for account creation
        (0, $7VwhR.ufoEventAccountCreation).start({
            productKey: product === null || product === void 0 ? void 0 : product.key,
            webPlatform: "bxp-ui"
        });
        const gRecaptchaResponse = await (0, $7VwhR.getRecaptcha)(email, executeRecaptcha);
        (0, $7VwhR.ufoEventAccountCreation).setCustomData({
            gRecaptchaResponse: gRecaptchaResponse !== null && gRecaptchaResponse !== void 0 ? gRecaptchaResponse : "none",
            executeRecaptchaExists: Boolean(executeRecaptcha),
            reactComponent: "AccountCreationContextProvider"
        });
        // Handle missing reCAPTCHA response
        if (!gRecaptchaResponse) {
            (0, $7VwhR.trackRecaptchaFailure)(createAnalyticsEvent, "account-creation");
            const invalidRecaptchaError = new Error("Missing reCAPTCHA token");
            (0, $7VwhR.ufoEventAccountCreation).failure({
                customData: {
                    reactComponent: "AccountCreationContextProvider"
                },
                error: invalidRecaptchaError
            });
            throw invalidRecaptchaError;
        }
        const existingUserRedirectUrl = await (0, $7VwhR.getMethodsAvailableRedirection)({
            email: email,
            application: identityCobranding,
            signupClient: signupClient,
            createAnalyticsEvent: createAnalyticsEvent,
            successRedirect: redirectTo
        }).catch((error)=>{
            setFormError(true);
            setIsSubmitting(false);
            (0, $7VwhR.trackSignupFailure)(createAnalyticsEvent);
            throw new Error(error);
        });
        if (existingUserRedirectUrl) {
            window.location.assign(existingUserRedirectUrl.replace("/initiate/password", ""));
            return;
        }
        const newUserRedirectTo = redirectTo + `&n2n=true`;
        (0, $7VwhR.ufoEventAccountCreation).startSubstep($835e146085c3a79b$var$IDENTITY_USER_SIGNUP_API);
        await signupClient.userSignup({
            application: identityCobranding,
            displayName: "",
            email: email,
            gRecaptchaResponse: gRecaptchaResponse,
            locale: intl.locale,
            products: [
                {
                    productKey: (product === null || product === void 0 ? void 0 : product.key) || (0, $7VwhR.ProductKey).JIRA_SOFTWARE,
                    edition: edition || "free"
                }
            ],
            redirectTo: newUserRedirectTo
        }).then(({ otpRedirect: otpRedirect })=>{
            (0, $7VwhR.ufoEventAccountCreation).endSubstep($835e146085c3a79b$var$IDENTITY_USER_SIGNUP_API);
            if (!otpRedirect) throw new Error("No OTP redirect");
            // Reliability SLO "good event" metric emitted for submit account creation
            (0, $7VwhR.ufoEventAccountCreation).success({
                customData: {
                    reactComponent: "AccountCreationContextProvider"
                }
            });
            (0, $7VwhR.trackSubmitSuccess)(createAnalyticsEvent);
            // Paid landing Jira AI experiment: tag OTP redirects when CGS key is present.
            if (templateId === "cfind-4666-jira-ai-preview") {
                var _searchParams_get;
                const cgsKey = typeof window !== "undefined" ? (_searchParams_get = new URL(window.location.href).searchParams.get("cgsKey")) !== null && _searchParams_get !== void 0 ? _searchParams_get : undefined : undefined;
                if (cgsKey) createAnalyticsEvent({
                    eventType: "track",
                    action: "succeeded",
                    actionSubject: "paidLandingJiraAiExperiment",
                    attributes: {
                        step: "OtpRedirected",
                        flow: "paidLandingJiraAi",
                        experimentKey: "cfind4666JiraFfl",
                        templateId: templateId,
                        cgsKey: cgsKey
                    }
                }).fire();
            }
            window.location.assign(otpRedirect);
        }).catch((error)=>{
            // Reliability SLO "bad event" metric emitted for submit account creation
            (0, $7VwhR.ufoEventAccountCreation).endSubstep($835e146085c3a79b$var$IDENTITY_USER_SIGNUP_API);
            (0, $7VwhR.ufoEventAccountCreation).failure({
                customData: {
                    reactComponent: "AccountCreationContextProvider"
                },
                error: error
            });
            setEmail(email);
            setFormError(true);
            setHasSubmitted(true);
            setIsSubmitting(false);
            (0, $7VwhR.trackSignupFailure)(createAnalyticsEvent);
            throw new Error(error);
        });
    }, [
        createAnalyticsEvent,
        edition,
        executeRecaptcha,
        identityCobranding,
        interstitialRedirectEnabled,
        intl.locale,
        isEmailValid,
        product,
        recaptchaRetryTimeRemainingSecond,
        redirectTo,
        signupClient
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (recaptchaFailedToLoad && recaptchaRetryTimeRemainingSecond <= 0) (0, $7VwhR.ufoEventAccountCreation).failure({
            customData: {
                reactComponent: "AccountCreationContextProvider",
                recaptchaRetryTimeRemainingSecond: 0
            },
            error: new Error("Recaptcha retry failed")
        });
        if (onSubmitProps && recaptchaFailedToLoad && executeRecaptcha) onSubmitWithReCAPTCHA(onSubmitProps).then(()=>{
            (0, $7VwhR.ufoEventAccountCreation).success({
                customData: {
                    reactComponent: "AccountCreationContextProvider",
                    analyticsEvent: "succeeded",
                    recaptchaRetryTimeRemainingSecond: recaptchaRetryTimeRemainingSecond
                }
            });
        }).catch((error)=>{
            setFormError(true);
            (0, $7VwhR.ufoEventAccountCreation).failure({
                customData: {
                    reactComponent: "AccountCreationContextProvider",
                    analyticsEvent: "errored",
                    recaptchaRetryTimeRemainingSecond: recaptchaRetryTimeRemainingSecond
                },
                error: error
            });
            return;
        }).finally(()=>{
            setIsSubmitting(false);
        });
    }, [
        executeRecaptcha,
        recaptchaFailedToLoad,
        onSubmitProps,
        onSubmitWithReCAPTCHA,
        recaptchaRetryTimeRemainingSecond
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (!recaptchaFailedToLoad) return;
        if (recaptchaRetryTimeRemainingSecond <= 0) return;
        const intervalId = setInterval(()=>{
            setRecaptchaRetryTimeRemainingSecond(recaptchaRetryTimeRemainingSecond - 1);
        }, 1000);
        return ()=>clearInterval(intervalId);
    }, [
        recaptchaFailedToLoad,
        recaptchaRetryTimeRemainingSecond
    ]);
    const onClickSocialButton = (provider)=>{
        (0, $7VwhR.trackContinueWithSocialSignups)(createAnalyticsEvent, provider, product === null || product === void 0 ? void 0 : product.key, edition);
        const socialRedirectUrl = (0, $7VwhR.getSocialButtonUrl)({
            redirectTo: redirectTo,
            identityCobranding: identityCobranding,
            provider: provider
        });
        window.location.assign(socialRedirectUrl);
    };
    const onClickSubmitButton = ()=>(0, $7VwhR.trackSubmitButtonClick)(createAnalyticsEvent);
    return /*#__PURE__*/ (0, $7VQPk.jsx)($835e146085c3a79b$export$52bc2238e0ff8657.Provider, {
        value: {
            dataFoundationsActionSubjectId: dataFoundationsActionSubjectId,
            edition: edition,
            formError: formError,
            hasSubmitted: hasSubmitted,
            identityCobranding: identityCobranding,
            isReadyForInvalid: isReadyForInvalid,
            isSubmitting: isSubmitting,
            onClickSocialButton: onClickSocialButton,
            onClickSubmitButton: onClickSubmitButton,
            onSubmitWithReCAPTCHA: onSubmitWithReCAPTCHA,
            product: product,
            redirectTo: redirectTo,
            setIsEmailValid: setIsEmailValid,
            setIsReadyForInvalid: setIsReadyForInvalid,
            setTypeAheadEmail: setTypeAheadEmail,
            typeAheadEmail: typeAheadEmail,
            tryIntentAnalyticsEventHasFired: tryIntentAnalyticsEventHasFired
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jmley.default), {
            edition: edition,
            intentType: "form",
            productKey: product === null || product === void 0 ? void 0 : product.key,
            onAnalyticsEventFired: ()=>!tryIntentAnalyticsEventHasFired && setTryIntentAnalyticsEventHasFired(true),
            children: children
        })
    });
};

});


parcelRegister("f5lYY", function(module, exports) {
$parcel$export(module.exports, "Error", function () { return (parcelRequire("mG5bv")).Error; });
parcelRequire("mG5bv");

});
parcelRegister("mG5bv", function(module, exports) {
$parcel$export(module.exports, "Error", function () { return $d2f561c370fddce6$export$edf27be85e5f6da0; });
/* error.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $2fk4i = parcelRequire("2fk4i");
parcelRequire("9ktVo");
var $cGEBM = parcelRequire("cGEBM");
const $d2f561c370fddce6$export$edf27be85e5f6da0 = ({ errorText: errorText })=>{
    const { formatMessage: formatMessage, locale: locale } = (0, $8e22h.default)();
    const { formError: formError } = (0, $cGEBM.useAccountCreationContext)();
    if (!formError) return null;
    if (errorText === undefined) errorText = locale === "en" // temporary fix until translation is available
     ? formatMessage({
        id: "AccountCreation.userSignupError",
        defaultMessage: `It's taking longer than expected to get you started. Please refresh and try again or <contactUsLink>contact us</contactUsLink>.`
    }, {
        contactUsLink: $d2f561c370fddce6$var$contactUsLink
    }) : formatMessage({
        id: "BxpUiSignup.SignupForm.formError",
        defaultMessage: "It's taking longer than expected to get you started. Please check your inbox to see if the order has completed successfully, or <contactUsLink>contact us</contactUsLink>."
    }, {
        contactUsLink: $d2f561c370fddce6$var$contactUsLink
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
        role: "alert",
        className: (0, $2jatx.default)([
            "_syaz1cjc _19pk1j6v _2hwxidpf _otyr1j6v _18u0idpf _3fcw150s"
        ]),
        children: errorText
    });
};
const $d2f561c370fddce6$var$contactUsLink = (text)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
        text: text,
        "aria-label": text,
        type: "inline",
        href: "/company/contact",
        className: "linkText"
    });
const $d2f561c370fddce6$var$errorCss = null;

});


parcelRegister("7PpcD", function(module, exports) {
$parcel$export(module.exports, "Input", function () { return (parcelRequire("irRyj")).Input; });
parcelRequire("irRyj");

});
parcelRegister("irRyj", function(module, exports) {
$parcel$export(module.exports, "Input", function () { return $5190fd2e8a96a930$export$f5b8910cec6cf069; });
/* input.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $igGC3 = parcelRequire("igGC3");

var $8KJ2x = parcelRequire("8KJ2x");

var $7VwhR = parcelRequire("7VwhR");

var $kbpa7 = parcelRequire("kbpa7");

var $32ng3 = parcelRequire("32ng3");
parcelRequire("9ktVo");
var $cGEBM = parcelRequire("cGEBM");
parcelRequire("1p00m");
var $6nMZs = parcelRequire("6nMZs");
const $5190fd2e8a96a930$var$HELP_TEXT_ID = "account_creation_email_help_text";
const $5190fd2e8a96a930$export$f5b8910cec6cf069 = ({ helpText: helpText, errorMessageText: errorMessageText, labelText: labelText, placeholderText: placeholderText })=>{
    const { isReadyForInvalid: isReadyForInvalid, setIsEmailValid: setIsEmailValid, setIsReadyForInvalid: setIsReadyForInvalid, setTypeAheadEmail: setTypeAheadEmail, typeAheadEmail: typeAheadEmail } = (0, $cGEBM.useAccountCreationContext)();
    const [email, setEmail] = (0, $1oC0p.useState)(typeAheadEmail);
    const [isValid, setValid] = (0, $1oC0p.useState)();
    const intl = (0, $8e22h.default)();
    if (helpText === undefined) helpText = intl.formatMessage({
        id: "signupForm.accountCreation.helperText",
        defaultMessage: "Using a work email helps find teammates and boost collaboration."
    });
    if (errorMessageText === undefined) errorMessageText = intl.formatMessage({
        id: "BxpUiSignup.SignupForm.invalidEmail",
        defaultMessage: "Please enter a valid email address."
    });
    if (labelText === undefined) labelText = intl.formatMessage({
        id: "BxpUiSignup.SignupForm.workEmail",
        defaultMessage: "Work email"
    });
    if (placeholderText === undefined) placeholderText = intl.formatMessage({
        id: "BxpUiSignup.SignupForm.emailPlaceholder",
        defaultMessage: "you@company.com"
    });
    (0, $1oC0p.useEffect)(()=>{
        const isValid = (0, $7VwhR.emailIsValid)(email);
        // wait to show invalid state if the user is not finished typing
        if (!isValid && !isReadyForInvalid) {
            setValid(undefined);
            return;
        }
        setValid(isValid);
        setIsEmailValid(isValid);
    }, [
        email,
        setIsEmailValid,
        isReadyForInvalid
    ]);
    const modalVisualUpdates = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).cfind4831ProductOverlayModalVisualUpdates);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_6rth7vkz _1rwq121t _1heubzd7 _125x1syg _62vcmccc _1d6jidpf _1t2q1kw7 _17rnbzd7 _1q9pbfng _d78pglyw",
            modalVisualUpdates && "_17rnjdj5 _1heujdj5"
        ]),
        style: {
            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
            "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text")),
            "--_1jvo4a6": (0, $6ZVlx.default)((0, $7VwhR.fontSize).md)
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
            "aria-required": true,
            isRequired: true,
            label: labelText,
            name: "email",
            children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_zbay183y",
                        isValid === true && "_1lo6qn1y",
                        isValid === false && "_1lo61wfy"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8KJ2x.default), (0, $dPABA._)((0, $6ogO3._)({}, fieldProps), {
                            autoComplete: "email",
                            "aria-describedby": $5190fd2e8a96a930$var$HELP_TEXT_ID,
                            elemAfterInput: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6nMZs.InputIcon), {
                                valid: isValid
                            }),
                            onBlur: ()=>setIsReadyForInvalid(true),
                            onChange: (e)=>{
                                setEmail(e.target.value);
                                setTypeAheadEmail(e.target.value);
                                fieldProps.onChange(e);
                            },
                            placeholder: placeholderText,
                            testId: "email_field",
                            type: "email",
                            value: email
                        })),
                        isValid === false ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            id: $5190fd2e8a96a930$var$HELP_TEXT_ID,
                            role: "alert",
                            className: (0, $2jatx.default)([
                                "_syaz1tmw _1wybepq8 _vwz4bs82 _1pfhi2wt"
                            ]),
                            style: {
                                "--_1h1y5xv": (0, $6ZVlx.default)((0, $7VwhR.fontSize).xs)
                            },
                            children: errorMessageText
                        }) : helpText ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            id: $5190fd2e8a96a930$var$HELP_TEXT_ID,
                            className: (0, $2jatx.default)([
                                "_syaz1io3 _1wybepq8 _vwz4bs82 _1pfhi2wt"
                            ]),
                            style: {
                                "--_138lqrp": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark500")),
                                "--_1h1y5xv": (0, $6ZVlx.default)((0, $7VwhR.fontSize).xs)
                            },
                            children: helpText
                        }) : null
                    ]
                })
        })
    });
};
const $5190fd2e8a96a930$var$errorMessageCss = null;
const $5190fd2e8a96a930$var$helpTextCss = null;
const $5190fd2e8a96a930$var$fieldCss = null;
// todo remove !important when we productionize gate and merge properties with fieldCss
const $5190fd2e8a96a930$var$fieldV2Css = null;
const $5190fd2e8a96a930$var$inputCss = null;
const $5190fd2e8a96a930$var$inputInvalidCss = null;
const $5190fd2e8a96a930$var$inputValidCss = null;

});
parcelRegister("1p00m", function(module, exports) {
$parcel$export(module.exports, "InputIcon", function () { return (parcelRequire("6nMZs")).InputIcon; });
parcelRequire("6nMZs");

});
parcelRegister("6nMZs", function(module, exports) {
$parcel$export(module.exports, "InputIcon", function () { return $f28bd5fc1ae39550$export$f8fea9f50a4bfae6; });
/* input-icon.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $kCGk7 = parcelRequire("kCGk7");

var $78jg9 = parcelRequire("78jg9");

var $7VwhR = parcelRequire("7VwhR");

var $kbpa7 = parcelRequire("kbpa7");
const $f28bd5fc1ae39550$export$f8fea9f50a4bfae6 = ({ valid: valid })=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    const validMessage = formatMessage({
        id: "signupForm.accountCreation.validEmailIcon",
        defaultMessage: "Success"
    });
    const invalidMessage = formatMessage({
        id: "signupForm.accountCreation.invalidEmailIcon",
        defaultMessage: "Warning"
    });
    if (valid === undefined) return null;
    return valid ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_4cvr1h6o _1e0c1txw _lswucd5j _1wyb1syg _y4tiftgi _syaz1ua5"
        ]),
        style: {
            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
            "--_1jvo4a6": (0, $6ZVlx.default)((0, $7VwhR.fontSize).md)
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($78jg9))), {
            label: validMessage
        })
    }) : /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_4cvr1h6o _1e0c1txw _lswucd5j _1wyb1syg _y4tiftgi _syaz1bqt"
        ]),
        style: {
            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
            "--_1jvo4a6": (0, $6ZVlx.default)((0, $7VwhR.fontSize).md)
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kCGk7))), {
            label: invalidMessage
        })
    });
};
const $f28bd5fc1ae39550$var$iconWrapperStyle = {
    alignItems: "center",
    display: "flex",
    fill: (0, $kbpa7.wacToken)("color.neutral.light0"),
    fontSize: (0, $7VwhR.fontSize).md,
    paddingInlineEnd: 8
};
const $f28bd5fc1ae39550$var$iconValidCss = null;
const $f28bd5fc1ae39550$var$iconInvalidCss = null;

});




parcelRegister("bncEF", function(module, exports) {
$parcel$export(module.exports, "Login", function () { return (parcelRequire("lJMiD")).Login; });
parcelRequire("lJMiD");

});
parcelRegister("lJMiD", function(module, exports) {
$parcel$export(module.exports, "Login", function () { return $50db90a6da99c80d$export$21a94553ffa41578; });
/* login.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $7VwhR = parcelRequire("7VwhR");

var $2fk4i = parcelRequire("2fk4i");

var $1ka2O = parcelRequire("1ka2O");
parcelRequire("9ktVo");
var $cGEBM = parcelRequire("cGEBM");
const $50db90a6da99c80d$export$21a94553ffa41578 = ({ loginText: loginText })=>{
    const intl = (0, $8e22h.default)();
    const location = (0, $1ka2O.useLocation)();
    const { product: product } = (0, $cGEBM.useAccountCreationContext)();
    if (loginText === undefined) loginText = intl.formatMessage({
        id: "BxpUiSignup.SignupForm.existingProduct",
        defaultMessage: "Already have {product}? <logInLink>Log in</logInLink>"
    }, {
        product: product === null || product === void 0 ? void 0 : product.description,
        logInLink: (text)=>$50db90a6da99c80d$var$logInLink(text, location)
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
        className: (0, $2jatx.default)([
            "_1wyb8oy7 _19pk14b4 _2hwxgrf3 _otyrgrf3 _18u0grf3 _y3gn1h6o"
        ]),
        style: {
            "--_djwknj": (0, $6ZVlx.default)((0, $7VwhR.fontSize).sm)
        },
        children: loginText
    });
};
const $50db90a6da99c80d$var$logInLink = (text, location)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
        text: text,
        "aria-label": text,
        type: "inline",
        href: (0, $7VwhR.getLoginUrl)(location)
    });
const $50db90a6da99c80d$var$existingProductCss = null;

});


parcelRegister("k0W5w", function(module, exports) {
$parcel$export(module.exports, "LogoButton", function () { return (parcelRequire("iTWJZ")).LogoButton; });
$parcel$export(module.exports, "ProviderLogo", function () { return (parcelRequire("iTWJZ")).ProviderLogo; });
$parcel$export(module.exports, "Social", function () { return (parcelRequire("32ARy")).Social; });
parcelRequire("iTWJZ");
parcelRequire("32ARy");

});
parcelRegister("32ARy", function(module, exports) {
$parcel$export(module.exports, "Social", function () { return $4e2e5c1067955974$export$9a0fadb2797ac9a5; });
/* social.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");
parcelRequire("9ktVo");
var $cGEBM = parcelRequire("cGEBM");

var $iTWJZ = parcelRequire("iTWJZ");
const $4e2e5c1067955974$export$9a0fadb2797ac9a5 = ({ providers: providers })=>{
    const intl = (0, $8e22h.default)();
    const { onClickSocialButton: onClickSocialButton } = (0, $cGEBM.useAccountCreationContext)();
    if (providers === undefined) providers = {
        google: "Google",
        microsoft: "Microsoft",
        apple: "Apple",
        slack: "Slack"
    };
    const buttons = Object.entries(providers);
    // when there are 3 buttons, we display in a single row and visually hide the text labels
    const rowStyle = buttons.length === 3;
    /* added role="list" to ul for safari https://developer.mozilla.org/en-US/docs/Web/CSS/list-style#accessibility  */ return /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
        role: "list",
        className: (0, $2jatx.default)([
            "_qtt8glyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
            buttons.length > 1 && !rowStyle && "_1e0c11p5 _zulp7vkz _yv0efsjm",
            rowStyle && "_1e0c11p5 _zulp7vkz _wij21bp4"
        ]),
        children: buttons.map(([provider, label])=>/*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $iTWJZ.LogoButton), {
                    "aria-label": intl.formatMessage({
                        id: "social.label.signup",
                        defaultMessage: "sign up with {provider}"
                    }, {
                        provider: label
                    }),
                    onClick: ()=>onClickSocialButton(provider),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iTWJZ.ProviderLogo), {
                            logo: provider
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                            className: (0, $2jatx.default)([
                                rowStyle && "_kqswstnw _1e021cib _152t1wug _1bsbt94y _4t3it94y _1reo15vq _18m915vq _ogtohxbz _o5721q9c"
                            ]),
                            children: label
                        })
                    ]
                })
            }, provider))
    });
};
const $4e2e5c1067955974$var$buttonGridCss = null;
const $4e2e5c1067955974$var$buttonListCss = null;
const $4e2e5c1067955974$var$buttonRowCss = null;
const $4e2e5c1067955974$var$srOnlyCss = null;

});


parcelRegister("kHTHh", function(module, exports) {
$parcel$export(module.exports, "Submit", function () { return (parcelRequire("l7G9R")).Submit; });
parcelRequire("l7G9R");

});
parcelRegister("l7G9R", function(module, exports) {
$parcel$export(module.exports, "Submit", function () { return $9e3c42c7c44204a7$export$2c4cf1f7b42ef78c; });
/* submit.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $5qUgh = parcelRequire("5qUgh");

var $2fk4i = parcelRequire("2fk4i");

var $32ng3 = parcelRequire("32ng3");
parcelRequire("9ktVo");
var $cGEBM = parcelRequire("cGEBM");
const $9e3c42c7c44204a7$export$2c4cf1f7b42ef78c = ({ buttonText: buttonText })=>{
    const intl = (0, $8e22h.default)();
    const { isSubmitting: isSubmitting, hasSubmitted: hasSubmitted, formError: formError, onClickSubmitButton: onClickSubmitButton } = (0, $cGEBM.useAccountCreationContext)();
    if (buttonText === undefined) buttonText = intl.formatMessage({
        id: "BxpUiSignup.SignupForm.submit",
        defaultMessage: "Sign up"
    });
    const modalVisualUpdates = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).cfind4831ProductOverlayModalVisualUpdates);
    if (modalVisualUpdates) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Button), {
        type: "submit",
        isDisabled: isSubmitting || hasSubmitted && !formError,
        isLoading: isSubmitting || hasSubmitted && !formError,
        onClick: onClickSubmitButton,
        className: (0, $2jatx.default)([
            "_ect41kw7 _1wyb7vkz _p12f1wug _1rjcftgi _1bsb1osq"
        ]),
        children: buttonText
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5qUgh.Adg4Button), {
        type: "submit",
        isDisabled: isSubmitting || hasSubmitted && !formError,
        isFullWidth: true,
        isLoading: isSubmitting || hasSubmitted && !formError,
        onClick: onClickSubmitButton,
        children: buttonText
    });
};
const $9e3c42c7c44204a7$var$buttonCss = null;

});








//# sourceMappingURL=confirmation-page.81d49f07.js.map
